/* Mattiva v3.0.0 — age gate. Cookie-only, 30 days, no personal data. */
(function () {
  'use strict';
  var COOKIE = 'mattiva_age_ok', DAYS = 30;
  function hasCookie() {
    return document.cookie.split(';').some(function (c) { return c.trim().indexOf(COOKIE + '=1') === 0; });
  }
  function setCookie() {
    var d = new Date(); d.setTime(d.getTime() + DAYS * 864e5);
    document.cookie = COOKIE + '=1; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
  }
  document.addEventListener('DOMContentLoaded', function () {
    var gate = document.getElementById('age-gate');
    if (!gate || hasCookie()) return;
    gate.hidden = false;
    gate.classList.add('is-open');
    document.documentElement.classList.add('age-gate-locked');
    var first = gate.querySelector('button');
    if (first) first.focus();
    gate.addEventListener('click', function (e) {
      var a = e.target.getAttribute && e.target.getAttribute('data-age-gate');
      if (!a) return;
      if (a === 'yes') {
        setCookie();
        gate.classList.remove('is-open');
        gate.hidden = true;
        document.documentElement.classList.remove('age-gate-locked');
      } else {
        window.location.href = 'https://www.google.com';
      }
    });
    gate.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var b = gate.querySelectorAll('button'), f = b[0], l = b[b.length - 1];
      if (e.shiftKey && document.activeElement === f) { e.preventDefault(); l.focus(); }
      else if (!e.shiftKey && document.activeElement === l) { e.preventDefault(); f.focus(); }
    });
  });
})();

/* Product gallery carousel — scroll-snap track, arrows appear only when
   there are more images than fit (i.e. more than 3 on desktop, 1 on mobile). */
(function () {
  'use strict';
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-gallery]').forEach(function (wrap) {
      var track = wrap.querySelector('[data-gallery-track]');
      var prev = wrap.querySelector('[data-gallery-prev]');
      var next = wrap.querySelector('[data-gallery-next]');
      if (!track || !prev || !next) return;

      function step() {
        var item = track.querySelector('.product-gallery__item');
        return item ? item.getBoundingClientRect().width + 12 : track.clientWidth;
      }
      function update() {
        var overflow = track.scrollWidth > track.clientWidth + 4;
        wrap.classList.toggle('has-overflow', overflow);
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  });
})();


/* Mobile nav toggle. */
(function () {
  'use strict';
  document.addEventListener('DOMContentLoaded', function () {
    var toggle = document.querySelector('[data-nav-toggle]');
    var header = toggle && toggle.closest('.site-header');
    if (!toggle || !header) return;
    // The drawer lives OUTSIDE the header element: the header's
    // backdrop-filter would otherwise trap position:fixed descendants.
    var drawer = document.querySelector('.mdrawer');
    function setOpen(open) {
      header.classList.toggle('nav-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (drawer) drawer.classList.toggle('is-open', open);
      document.body.classList.toggle('nav-lock', open && window.innerWidth <= 820);
    }
    document.querySelectorAll('[data-nav-close]').forEach(function (b) {
      b.addEventListener('click', function () { setOpen(false); });
    });
    toggle.addEventListener('click', function () {
      setOpen(!header.classList.contains('nav-open'));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });
    document.querySelectorAll('.site-header__nav a, .mdrawer a').forEach(function (a) {
      a.addEventListener('click', function () { setOpen(false); });
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 820) setOpen(false);
    });
  });
})();


/* Purchase widget: supply cards (collapsed until selected), subscribe/one-time
   toggle, quantity stepper, live button price. Selling plans come from the
   Shopify Subscriptions app; without plans the widget degrades to one-time. */
(function () {
  'use strict';
  document.addEventListener('DOMContentLoaded', function () {
    var form = document.querySelector('[data-buy-widget]');
    if (!form) return;
    var idInput = form.querySelector('[data-id-input]');
    var planInput = form.querySelector('[data-plan-input]');
    var qtyInput = form.querySelector('[data-qty]');
    var btnPrice = form.querySelector('[data-btn-price]');
    var cards = Array.prototype.slice.call(form.querySelectorAll('[data-plan-card]'));
    var mode = planInput && !planInput.disabled ? 'subscribe' : 'onetime';

    function selectedCard() {
      return form.querySelector('[data-plan-card].is-selected') || cards[0];
    }
    function unitCents() {
      var c = selectedCard();
      if (mode === 'subscribe' && c.dataset.planPrice) return parseInt(c.dataset.planPrice, 10);
      return parseInt(c.dataset.price, 10);
    }
    function fmt(cents) {
      return '$' + (cents / 100).toFixed(2);
    }
    function update() {
      var c = selectedCard();
      var hasPlan = !!c.dataset.planId;
      var useSub = mode === 'subscribe' && hasPlan;
      idInput.value = c.dataset.variantId;
      if (planInput) {
        planInput.disabled = !useSub;
        if (useSub) planInput.value = c.dataset.planId;
      }
      // price + chip visibility on the card that has both modes
      cards.forEach(function (card) {
        var ps = card.querySelector('[data-price-sub]');
        var po = card.querySelector('[data-price-one]');
        var cs = card.querySelector('[data-chip-sub]');
        var co = card.querySelector('[data-chip-one]');
        var vs = card.querySelector('[data-per-sub]');
        var vo = card.querySelector('[data-per-one]');
        // An unselected plan card keeps its subscribe framing (pill always
        // visible); the selected card follows the toggle.
        var showSub = !!card.dataset.planId && (card !== c || useSub);
        if (ps) ps.hidden = !showSub;
        if (po) po.hidden = showSub;
        if (cs) cs.hidden = !showSub;
        if (co) co.hidden = showSub;
        if (vs) vs.hidden = !showSub;
        if (vo) vo.hidden = showSub;
      });
      var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      var total = unitCents() * qty;
      // Stock-up nudge: one-time only; mirrors the automatic discount at checkout.
      var bulk = form.querySelector('[data-bulk]');
      var bulkMet = false;
      if (bulk) {
        var bq = parseInt(bulk.dataset.bulkQty, 10) || 3;
        var bp = parseInt(bulk.dataset.bulkPct, 10) || 0;
        bulk.hidden = useSub;
        var bt = bulk.querySelector('[data-bulk-text]');
        var full = parseInt(c.dataset.price, 10) * bq;
        var disc = Math.round(full * (100 - bp) / 100);
        bulkMet = !useSub && qty >= bq;
        bulk.classList.toggle('is-met', bulkMet);
        if (bt) bt.innerHTML = bulkMet
          ? '\u2713 ' + bp + '% off applied at checkout'
          : 'Buy ' + bq + ', save ' + bp + '% \u2014 <s>' + fmt(full) + '</s> ' + fmt(disc);
        if (bulkMet) total = Math.round(total * (100 - bp) / 100);
      }
      if (btnPrice) btnPrice.textContent = fmt(total);
      var buyBtn = form.querySelector('[data-buy-btn]');
      if (buyBtn) {
        var avail = c.dataset.available !== 'false';
        buyBtn.disabled = !avail;
        var lb = buyBtn.querySelector('[data-btn-buy]');
        var ls = buyBtn.querySelector('[data-btn-soldout]');
        if (lb) lb.hidden = !avail;
        if (ls) ls.hidden = avail;
      }
    }

    cards.forEach(function (card) {
      var radio = card.querySelector('[data-plan-radio]');
      card.addEventListener('click', function () {
        if (card.classList.contains('is-selected')) return;
        cards.forEach(function (o) { o.classList.remove('is-selected', 'is-open'); });
        card.classList.add('is-selected', 'is-open');
        if (radio) radio.checked = true;
        // One-time is the business default: selecting any card resets to it.
        mode = 'onetime';
        syncModeUI();
        update();
      });
    });

    function syncModeUI() {
      form.querySelectorAll('[data-mode-btn]').forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-mode-btn') === mode);
      });
      form.querySelectorAll('[data-sub-benefits]').forEach(function (ul) {
        ul.style.display = mode === 'subscribe' ? '' : 'none';
      });
    }
    form.querySelectorAll('[data-mode-btn]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        mode = btn.getAttribute('data-mode-btn');
        syncModeUI();
        update();
      });
    });

    var minus = form.querySelector('[data-qty-minus]');
    var plus = form.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); update();
    });
    if (plus) plus.addEventListener('click', function () {
      qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; update();
    });
    qtyInput.addEventListener('change', update);

    // Stock-up nudge click → jump quantity to the unlock amount.
    var bulkBtn = form.querySelector('[data-bulk]');
    if (bulkBtn) bulkBtn.addEventListener('click', function () {
      var bq = parseInt(bulkBtn.dataset.bulkQty, 10) || 3;
      if ((parseInt(qtyInput.value, 10) || 1) < bq) qtyInput.value = bq;
      update();
    });

    // Delivery-frequency radios (when a variant carries more than one plan).
    form.querySelectorAll('[data-freq-radio]').forEach(function (r) {
      r.addEventListener('click', function (e) { e.stopPropagation(); });
      r.addEventListener('change', function () {
        var card = r.closest('[data-plan-card]');
        if (!card) return;
        card.dataset.planId = r.value;
        card.dataset.planPrice = r.dataset.planPrice;
        card.dataset.planPriceFmt = r.dataset.planPriceFmt;
        var ps = card.querySelector('[data-price-sub] strong');
        if (ps) ps.textContent = r.dataset.planPriceFmt;
        var per = card.querySelector('[data-per-sub]');
        var sv = parseInt(card.dataset.servings, 10) || 0;
        if (per && sv > 0) per.textContent = fmt(Math.round(parseInt(r.dataset.planPrice, 10) / sv));
        var ship = card.querySelector('[data-ship-text]');
        var lbl = r.parentNode.querySelector('span');
        if (ship && lbl) ship.textContent = lbl.textContent.trim();
        update();
      });
    });
    // Clicks inside the frequency box must not re-select the card (which resets to one-time).
    form.querySelectorAll('.plan-freq').forEach(function (el) {
      el.addEventListener('click', function (e) { e.stopPropagation(); });
    });

    syncModeUI();
    update();
  });
})();